import apiInstance from "@services/Shared/instanceAxios";

const getSuperuser = (walletAddress: string) =>
  apiInstance({
    url: `/superusers/${walletAddress}`,
  });

export default getSuperuser;
